<template lang="html">

  <section class="ficha-evento">

    <encabezado :data="'eventos'"></encabezado>


    <div class="wrapper container" v-if="!!data">


      <section class="info-evento">

        <aside>

          <div class="tags row-between">
            <span class="categoria">{{data.categoria}}</span>
            <span class="destacado" v-if="data.destacado">
              <img src="/static/img/icons/icono-destacado-dark.svg" alt="Evento destacado">
              {{$t('eventos.evento_destacado')}}
            </span>
          </div>

          <h2 class="titulo" v-html="data.titulo"></h2>


          <p class="fecha">
            {{$t('eventos.desde')}} <strong>{{data.fecha | fecha}}</strong><br>
            {{$t('eventos.hasta')}} <strong>{{data.fechaFinalizacion | fecha}}</strong>
          </p>


          <p class="horario">{{data.horario}}</p>

          <p class="lugar">
            <strong>{{data.lugar}}</strong>
          </p>


          <p class="organizador">
            {{$t('eventos.organizado_por')}}: <strong>{{data.organizador}}</strong>
          </p>

          <p class="precio">
            <strong>{{data.coste}}</strong>
          </p>

          <template v-if="getLogged">
            <a @click="inscribirse" v-if="!!!data.alumnoYaInscrito && !!data.inscripcionHabilitada" :loading="loading"
              class="btn -solid-primary">{{$t('eventos.inscribirse')}}</a>
          </template>
          <template v-if="!getLogged">
            <router-link v-if="!!data.inscripcionHabilitada" :to="$t('enlaces.eventos')+'/'+data.urlAcceso"
              class="btn -solid-primary">{{$t('eventos.inscribirse')}}</router-link>
          </template>


          <p class="btn -skull-primary" v-if="data.alumnoYaInscrito">{{$t('eventos.inscrito')}}</p>

        </aside>

        <main>

          <img :src="data.ulrImagenPrincipal" :alt="data.titulo">
          <h2 class="titulo" v-html="data.titulo"></h2>
          <div class="descripcion" v-html="data.descripcion"></div>
          <a v-if="!!data.enlace" :href="data.enlace" target="_blank" class="mas-informacion">{{$t('eventos.mas_informacion')}}</a>
        </main>

      </section>

      <section class="imagenes-evento" v-if="!!data.listUrlImgs">

        <h3 class="title-section">{{$t('eventos.galeria')}}</h3>

        <div class="imagenes row-start">
          <div class="imagen" v-for="(img,key) in data.listUrlImgs">
            <img :src="img" alt="" @click="setslider(key+1)">
          </div>
        </div>

      </section>
      <section class="videos-evento row-between" v-if="!!data.urlVideo1 || !!data.urlVideo2">
        <h3 class="title-section">{{$t('eventos.videos')}}</h3>

        <iframe v-if="!!data.urlVideo1" :src="$options.filters.urlToID(data.urlVideo1)" title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
        <iframe v-if="!!data.urlVideo2" :src="$options.filters.urlToID(data.urlVideo2)" title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>

      </section>

      <div class="contenedor-slider" v-if="showslider">
        <button class="close" @click="showslider = false">✕</button>
        <div class="slider">
          <slick ref="slickgaleria" :options="slickOptions">
            <div class="imagen-slide" v-for="img in data.listUrlImgs">
              <img :src="img" alt="">
            </div>
          </slick>
        </div>
      </div>


    </div>

    <loading v-else></loading>

    <!-- FIN DE LA FICHA -->

  </section>

</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex'

  import encabezado from '@/components/parts/encabezado';

  import loading from '@/components/parts/loading';

  import Slick from 'vue-slick';

  export default {
    name: 'ficha-evento',
    props: [],
    created() {

      if (this.$route.name == 'evento-ficha') {
        this.requestEvento(this.$route.params.id)
          .then((result) => {
            this.data = result;
          })
      } else {
        this.requestEventoPublico(this.$route.params.id)
          .then((result) => {
            this.data = result;
          })
      }
    },
    data() {
      return {
        data: null,
        loading: false,
        showslider: false,
        slickOptions: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          dots: false,
          arrows: true,
          adaptiveHeight: false,
          autoplay: false,
          autoplaySpeed: 4000,
        },
      }
    },
    methods: {
      ...mapActions(['requestEvento', 'requestInscripcion', 'requestEventoPublico']),
      inscribirse() {
        this.loading = true;
        this.requestInscripcion(this.data.idEvento).then(r => {
          this.loading = false;
          if (r) {
            this.data.alumnoYaInscrito = true;
          }
        })
      },
      setslider(n){
                this.showslider = true;
                setTimeout(() => {
                    console.log(n)
                    this.$refs.slickgaleria.goTo(n-1);
                },200)
            }
    },
    computed: {
      ...mapGetters(['getServer', 'getLogged'])
    },
    components: {
      'encabezado': encabezado,
      'loading': loading,
      Slick
    },
    filters: {
      fecha(value) {
        let date = new Date(value);
        let meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']

        return `${date.getDate()} de ${meses[date.getMonth()]} de ${date.getFullYear()}`

      },
      urlToID(value) {

        let string;

        if (value.includes('youtube')) {
          string = 'https://www.youtube-nocookie.com/embed/' + value.split("?v=")[1];
        } else if (value.includes('vimeo')) {
          string = 'https://player.vimeo.com/video/' + value.split("/").pop();
        }

        return string;
      }
    }
  }
</script>

<style scoped lang="scss">
  	.contenedor-slider {
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.8);
		z-index: 20;
		padding: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
		.slider {
			width: 100%;
			max-width: 1200px;
      display: inline-block;
      text-align:center;

			img {
				max-width: 100%;
				max-height: 80vh;
        display: inline-block;
			}
		}

		.close {
			position: absolute;
			right: 20px;
			top: 20px;
			width: 60px;
			height: 60px;
			font-size: 30px;
			border-radius: 50%;
			border: none;
			color: white;
			outline: none;
			cursor: pointer;
      background: none;
		}

		.slick-prev {
			left: -80px;
			top: 50%;
			width: 50px;
			height: 80px;
			margin-top: -40px;
			outline: none;
			border: none;
			font-size: 0;
			position: absolute;
			background: url(/img/prev-arrow.svg) center no-repeat;
			cursor: pointer;
		}

		.slick-next {
			right: -80px;
			top: 50%;
			width: 50px;
			height: 80px;
			margin-top: -40px;
			outline: none;
			border: none;
			font-size: 0;
			position: absolute;
			background: url(/img/next-arrow.svg) center no-repeat;
			cursor: pointer;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/views/eventos/ficha-evento.vue